
module.exports = function equal(arr1, arr2) {
  var length = arr1.length
  if (length !== arr2.length) return false
  for (var i = 0; i < length; i++)
    if (arr1[i] !== arr2[i])
      return false
  return true
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/array-equal/index.js
// module id = G9WA
// module chunks = 1